export default "__VITE_ASSET__DhjZEdpQ__"